module.exports = __webpack_public_path__ + "img/btn.2482b214.png";